import { render, staticRenderFns } from "./module-unit.vue?vue&type=template&id=faaa7f32&scoped=true"
import script from "./module-unit.vue?vue&type=script&lang=js"
export * from "./module-unit.vue?vue&type=script&lang=js"
import style0 from "./module-unit.vue?vue&type=style&index=0&id=faaa7f32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaa7f32",
  null
  
)

export default component.exports